import React from "react";

import { DocumentLine } from "api";
import ContractTabTable from "components/SortableTable/SortableStripedTable";

const TermsTable = ({
  priceUnit,
  terms,
}: {
  terms: ContractTerms;
  priceUnit: string;
}): React.ReactElement => {
  const termsColumns: ColumnDefinition<DocumentLine>[] = React.useMemo(
    () => [
      {
        property: "shipFrom",
        sortKey: "WarehouseCode",
        columnLabel: "Ship From",
      },
      {
        property: "shipTo",
        sortKey: "Region",
        columnLabel: "Ship To",
      },
      {
        property: "mode",
        sortKey: "ModeOfTransportationCode",
        columnLabel: "Mode",
      },
      {
        property: "salesTerms",
        sortKey: "SalesTermsCode",
        columnLabel: "Sales Terms",
      },
      {
        property: "price",
        sortKey: "Price",
        columnLabel: `Price/${priceUnit}`,
      },
    ],
    [priceUnit]
  );
  return (
    <ContractTabTable
      values={terms}
      columns={termsColumns as ColumnDefinition[]}
    />
  );
};

export default TermsTable;
